import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@material-ui/core/Box/Box';
import Button from '@material-ui/core/Button/Button';
import Dialog from '@material-ui/core/Dialog/Dialog';
import DialogActions from '@material-ui/core/DialogActions/DialogActions';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle/DialogTitle';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { useEffect, useState } from 'react';
import getText from '../../nl-lib/i18n/language';
const useStyles = makeStyles({
    root: {
        width: '100%',
    },
});
function SimpleDialog(props) {
    // const classes = useStyles();
    const { onClose, open } = props;
    const handleClose = () => {
        onClose();
    };
    if (open) {
        setTimeout(() => {
            onClose();
        }, 1000);
    }
    return (_jsx(Dialog, Object.assign({ onClose: handleClose, "aria-labelledby": "simple-dialog-title", open: open }, { children: _jsxs(DialogTitle, Object.assign({ id: "simple-dialog-title" }, { children: [getText("print_cancel_ready_ok_warn1"), _jsx("br", {}), getText("print_cancel_ready_ok_warn2")] })) })));
}
const msgs = [
    getText("print_ready_to_cancel"),
    getText("print_cancel_ready_expalin"),
    getText("print_sorry_but_more")
];
export default function CancelWaitingDialog(props) {
    const classes = useStyles();
    const [okDlg, setOK] = useState(false);
    const [msgId, setMsgId] = useState(0);
    const [intervalID, setIntervalID] = useState(undefined);
    const handleClose = () => {
        setOK(true);
    };
    const reactionClosed = () => {
        setOK(false);
    };
    useEffect(() => {
        if (props.open) {
            if (intervalID === undefined) {
                const interval = setTimeout(() => {
                    setMsgId((msgId + 1) % msgs.length);
                    console.log("RRR: interval");
                }, 10);
                setIntervalID(interval);
            }
        }
        else {
            console.log('RRR: closed');
        }
    }, [props.open, intervalID]);
    useEffect(() => {
        setMsgId(0);
        return () => {
            console.log('RRR: EXIT');
            setMsgId(0);
        };
    }, []);
    return (_jsxs(React.Fragment, { children: [_jsxs(Dialog, Object.assign({ open: props.open }, { children: [_jsx(DialogTitle, Object.assign({ id: "form-dialog-title", style: { float: "left", width: "500px" } }, { children: _jsx(Box, Object.assign({ fontSize: 20, fontWeight: "fontWeightBold" }, { children: getText("print_cancel_ready") })) })), _jsx(DialogContent, { children: _jsx("div", Object.assign({ className: classes.root }, { children: _jsx(Box, Object.assign({ fontSize: 16, fontWeight: "fontWeightRegular" }, { children: msgs[msgId] })) })) }), _jsx(DialogActions, { children: _jsx(Button, Object.assign({ onClick: handleClose, color: "primary" }, { children: getText("print_cancel_ready_ok") })) })] })), _jsx(SimpleDialog, { open: okDlg, onClose: reactionClosed })] }));
}
//# sourceMappingURL=CancelWaitingDialog.js.map